import { PaymentMethodTypes, Paypal } from '@accedo/one-plugin-sdk';
import { t } from 'i18next';
import { useState } from 'react';

import { FormButton } from '#/components/Form/Form.styled';
import { FormButtonDisclaimer } from '#/components/Form/FormButton';

import * as Styled from './styled';
import { PaymentFormProps } from './types';

const PaymentPayPalForm = ({
  disclaimerText = 'web.iap.paymentFooter',
  onPurchase,
  onFailure,
  onSuccess,
}: PaymentFormProps) => {
  const [loading, setLoading] = useState(false);

  const handleClickButton = () => {
    setLoading(true);
    onPurchase({ paymentMethod: { type: PaymentMethodTypes.Paypal } })
      .then(({ paymentMethod, isExternal = true } = {}) => {
        const paypalResult = paymentMethod?.properties as Paypal;

        if (!isExternal) {
          onSuccess();

          return;
        }

        if (paypalResult?.redirectUrl) {
          window.open(paypalResult.redirectUrl, '_self');
        }
        // there is no onSuccess call here, because in this case, success must be handled after the redirect back.
      })
      .catch(onFailure)
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Styled.Text>
        {t('web.iap.paymentMethods.paypal.description')}
      </Styled.Text>
      <Styled.DisclaimerWrapper>
        <FormButtonDisclaimer disclaimer={t(disclaimerText)}>
          <FormButton isLoading={loading} onClick={handleClickButton}>
            {t('web.iap.paymentMethods.paypal.button')}
          </FormButton>
        </FormButtonDisclaimer>
      </Styled.DisclaimerWrapper>
    </>
  );
};

export default PaymentPayPalForm;
